<template>
        <div ref="commentBox" class="k-panel">
            <div class="k-panel__body">

                <div v-if="reaction !== null" class="k-reaction">

                    <a @click="cancelReaction" class="k-reaction__remove" href="javascript:;" title="Zrušit reakci">
                        <svg role="img" width="15" height="15" class="k-btn__icon k-btn__icon--rotate"><use fill="currentColor" xlink:href="/images/spritesheet.svg#add"></use></svg>
                    </a>

                    <div class="k-reaction__author">
                        {{ reaction.user.name }} napsal(a):
                    </div>

                    <div class="k-reaction__text">
                        {{ reaction.content }}
                    </div>

                </div>

                <form @submit.prevent="sendForm" class="k-form">

                    <div class="k-form__group">
                        <label class="k-form__label">Komentář</label>
                        <textarea ref="commentTextarea" v-model="form.content" class="k-form__textarea" placeholder="Zadejte text komentáře"></textarea>
                        <field-error v-if="form_errors.content" >{{ form_errors.content[0] }}</field-error>
                    </div>

                    <button type="submit" class="k-btn k-btn--primary">
                        Odeslat komentář
                    </button>
                </form>

            </div>
        </div>
</template>

<script>
    import FormBase from '../FormBase.vue';

    export default {
        extends: FormBase,

        data: function () {
            return {
                form: {
                    content: '',
                    reaction_id: ''
                },
                reaction: null
            }
        },

        methods: {
            /**
             * React on comment
             *
             * @return void
             */
            reactOnComment: function(comment) {
                // scroll to comment box
                if (this.$refs.commentBox) {
                    this.$scrollTo(this.$refs.commentBox, 1000, {offset: -140});
                }
                this.reaction = comment;
                this.form.reaction_id = comment.id;
                this.$refs.commentTextarea.focus();
            },

            /**
             * Cancel reaction
             *
             * @return void
             */
            cancelReaction: function() {
                this.reaction = null;
                this.form.reaction_id = '';
            },

            /**
             * Send form
             *
             * @returns {Promise<void>}
             */
            sendForm: async function() {
                let result = await this.sendData();
                if (result !== undefined) {
                    if (result.success === true) {
                        this.$emit('commentAdded', result.data.comment_id);
                        this.form.content = '';
                        this.cancelReaction();
                    }
                    // flash message
                    if (result.message.length) {
                        flash(result.message, result.success ? 'success' : 'danger');
                    }
                }
            }
        }
    }
</script>
